import React from "react";

const ContactHero = () => {
  return (
    <section className="relative py-12 md:py-20 bg-[#7D192A] flex items-center justify-center text-center overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
          alt="Support and inquiry desk for Reflection Futbol Academy"
          fetchPriority="high"
          width={1200}
          height={800}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto site-gutter">
        <h1 className="page-hero-title text-white uppercase tracking-tight">
          Contact Us
        </h1>
        <div className="mt-3 md:mt-4 h-1 w-16 md:h-2 md:w-32 bg-[#F4B400] mx-auto rounded-full" />
      </div>
    </section>
  );
};

export default ContactHero;
